import { render, staticRenderFns } from "./GalleryWeddingCake.vue?vue&type=template&id=36b3f946&scoped=true&"
import script from "./GalleryWeddingCake.vue?vue&type=script&lang=js&"
export * from "./GalleryWeddingCake.vue?vue&type=script&lang=js&"
import style0 from "./GalleryWeddingCake.vue?vue&type=style&index=0&id=36b3f946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3f946",
  null
  
)

export default component.exports